import { render, staticRenderFns } from "./RecoverPasswordFormView.vue?vue&type=template&id=168b8bcb&lang=pug"
import script from "./RecoverPasswordFormView.vue?vue&type=script&lang=js"
export * from "./RecoverPasswordFormView.vue?vue&type=script&lang=js"
import style0 from "./RecoverPasswordFormView.vue?vue&type=style&index=0&id=168b8bcb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports